import React from 'react';
import PageIframe from 'App/components/PageIframe/PageIframe';
import { usePageIframeInit, type PageRecordIds } from 'App/components/PageIframe/usePageIframeInit';
import './OrderPage.scss';

type Props = PageRecordIds & {
	/** Slug of the agent_page to embed (any record placement but 'clientCard'). */
	slug: string;
	/** The record's account, if any — exposed to the page via `useAccount()`. */
	clientId: number | null;
};

/**
 * Embeds a sandboxed Upsales Page as a tab inside a record: the order edit modal
 * (WEB-6999), the project drawer (WEB-13531), and the contact card, agreement and
 * appointment (WEB-13915). The record's id and its company go into the iframe
 * init so the page's record hook (`useOrder()`, `useContact()`, ...) and
 * `useAccount()` resolve to the record being viewed.
 */
export default function OrderPage({ slug, clientId, ...record }: Props) {
	const init = usePageIframeInit(clientId, record);

	return (
		<div className="OrderAgentPage">
			<PageIframe slug={slug} init={init} />
		</div>
	);
}
